import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Translation } from 'react-i18next';

export default class ToggleButton extends Component {
  grey = '#BEBEBE';

  render() {
    const {
      className,
      color,
      id,
      offLabel,
      onClick,
      onLabel,
      value,
      disabled = false,
      overRideBorderStyle,
      classRec = false,
      showLabel,
      toggleFillIcon,
      buttonContainerStyle,
      ariaLabel,
      backgroundStyle = {},
    } = this.props;
    const labelOffStyle = classRec
      ? 'class-rec-toggle-button-label-off'
      : 'toggle-button-label';
    const labelOnStyle = classRec
      ? 'class-rec-toggle-button-label-on'
      : 'toggle-button-label';
    return (
      <Translation>
        {(t) => (
          <button
            id={id}
            data-cy="toggle-button"
            tabIndex={0}
            className={classNames({
              'toggle-button': true,
              [className]: className,
            })}
            disabled={disabled}
            role="switch"
            onClick={onClick}
            aria-checked={!!value}
            type="button"
            aria-label={ariaLabel}
          >
            {showLabel ? (
              <span className={labelOffStyle}>{offLabel || t('Off')}</span>
            ) : null}
            <span
              style={backgroundStyle}
              className={classNames({
                'toggle-button-container': true,
                [buttonContainerStyle]: buttonContainerStyle,
              })}
            >
              <span
                className={['toggle-button-slider', overRideBorderStyle].join(
                  ' '
                )}
                style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
              >
                <span
                  className={classNames({
                    'toggle-button-slider-thumb': !toggleFillIcon,
                    on: value,
                  })}
                  style={{
                    background: value && !disabled ? color : this.grey,
                    cursor: disabled ? 'not-allowed' : 'pointer',
                  }}
                >
                  {toggleFillIcon || null}
                </span>
              </span>
            </span>
            {showLabel ? (
              <span className={labelOnStyle}>{onLabel || t('On')}</span>
            ) : null}
          </button>
        )}
      </Translation>
    );
  }
}

ToggleButton.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  onClick: PropTypes.func,
  value: PropTypes.bool,
};
